import { useContext } from 'react';
import { RootLevelFlagsContext } from '../../contexts/RootLevelFlagContext/RootLevelFlagsContextProvider';

export function useAuth0ConsolidateAuthTokenStorage() {
  const { flags } = useContext(RootLevelFlagsContext);

  return flags.useAuth0ConsolidateAuthTokenStorage;
}
